import React from "react";
import { Figure, FigureProps } from "../components/Figure";
import { MaxWidth } from "../layouts/MaxWidth";
import { Spacing } from "../layouts/Spacing";
import styles from "./StoryHero.module.css";
import { Video } from "../components/Video";
import { LinkWrapper } from "../components/linkWrapper";

export type StoryHeroProps = {
  title: string;
  category?: string;
  tag: string;
  image: FigureProps["image"];
  video?: string;
  caption?: string;
};

export const StoryHero = ({
  title,
  category = "verhalen",
  tag,
  image,
  video,
  caption,
}: StoryHeroProps) => {
  return (
    <Spacing>
      <MaxWidth size="md">
        <h1 className={styles.heading}>
          <small className={styles.preTitle}>
            <LinkWrapper url="verhalen">
              {category} {tag && <>• {tag}</>}
            </LinkWrapper>
          </small>
          <svg
            width="204"
            height="5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={styles.scribble}
          >
            <path
              d="M129.181 4.787c-14.662 0-29.313.017-43.975-.017-2.385-.009-4.759-.324-7.156-.435-2-.094-4.012-.145-6.012-.145-24.493-.034-40.678-.05-65.183-.076-2 0-4.012-.06-6.012-.137-.3-.017-.735-.281-.83-.486-.073-.17.192-.562.433-.639 2.024-.605 4.06-1.117 6.349-1.1 3.807.035-.682-.093 3.125-.119 1.819-.008 3.554-.06 5.096-.946.71-.409 1.82-.528 2.783-.63.988-.103 2-.035 3.012-.035 21.288.051 42.565.068 63.853.17 4.398.026 8.783.538 13.168.546 36.336.077 60.683.085 97.019.12 2.603 0 5.217.05 7.819.153.446.017.988.375 1.265.682.314.34-.578 1.168-1.289 1.219 0 0-2.397.17-3.59.17l-9.082.009c-3.205 0-3.856-.614-6.723.886-1.108.58-5.542 1.023-7.12 1.023-10.638-.009-21.277-.077-31.927-.11-5.024-.018-10.036 0-15.059 0 .036-.035.036-.069.036-.103Z"
              fill="#4E47FF"
            />
          </svg>
          <span className={styles.title}>{title}</span>
        </h1>
        {video ? (
          <Video poster={image} video={video} caption={caption} />
        ) : (
          <Figure image={image} caption={caption} width={960} height={640} />
        )}
      </MaxWidth>
    </Spacing>
  );
};
